"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 25",
    width: "28",
    height: "25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M15.1,23H0.5C0.2,23,0,22.8,0,22.5S0.2,22,0.5,22h14.6c0.3,0,0.5,0.2,0.5,0.5S15.4,23,15.1,23z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#97BF0D",
    d: "M16.4,14.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4.3,23c0,0-0.1,0-0.1,0c-0.3-0.1-0.4-0.4-0.3-0.6l6.2-22C10.1,0.1,10.3,0,10.5,0h1.9 c0.2,0,0.4,0.1,0.5,0.4l3.8,13.6c0.1,0.3-0.1,0.5-0.3,0.6c-0.3,0.1-0.5-0.1-0.6-0.3L12,1h-1.1L4.8,22.6C4.7,22.8,4.5,23,4.3,23z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#9ECE06",
    points: "9.2,5.3 13.8,5.3 14.9,9.1 8.1,9.1       "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M16.4,14.6l-0.2-0.7H6.8l-1.1,3.8h9.5C15.2,16.6,15.6,15.4,16.4,14.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.4,21.6c-0.1,0-0.3-0.1-0.3-0.1l-2.8-2.7c-0.2-0.2-0.2-0.5,0-0.7c0.2-0.2,0.5-0.2,0.7,0l2.4,2.4l3.6-3.8 c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-3.9,4.2C21.7,21.5,21.5,21.6,21.4,21.6C21.4,21.6,21.4,21.6,21.4,21.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.7,25c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2S25.2,25,21.7,25z M21.7,13.5c-2.9,0-5.2,2.3-5.2,5.2 s2.3,5.2,5.2,5.2s5.2-2.3,5.2-5.2S24.6,13.5,21.7,13.5z"
  }));
};

exports["default"] = _default;